import { db } from '../services/firebase';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';

export const generateUniqueReservationNumber = async (createdAt = new Date()) => {
  const date = createdAt?.toDate ? createdAt.toDate() : createdAt;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const counterKey = `${year}${month}`;
  
  try {
    const counterRef = doc(db, 'counters', 'reservations');
    const counterDoc = await getDoc(counterRef);
    
    let nextNumber = 1;
    
    if (counterDoc.exists()) {
      const data = counterDoc.data();
      nextNumber = (data[counterKey] || 0) + 1;
      
      await updateDoc(counterRef, {
        [counterKey]: nextNumber
      });
    } else {
      await setDoc(counterRef, {
        [counterKey]: nextNumber
      });
    }
    
    const sequence = String(nextNumber).padStart(3, '0');
    return `${year}${month}${sequence}`;
    
  } catch (error) {
    console.error('Erreur génération numéro:', error);
    return `TEMP${Date.now()}`;
  }
};